import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import React, { FC, useEffect, useState } from 'react';
import { Close } from '@material-ui/icons';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useDispatch } from 'react-redux';
import { productActions } from '../../data-management/productsSlice';
import { useProducts } from '../../hooks/useProducts';
import { InputProps as StandardInputProps } from '@material-ui/core/Input/Input';
import { useProduct } from '../../hooks/useProduct';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

type FrontPanelOffModalProps = {
  open: boolean
  onClose: () => void
}

export const FrontpanelOffModal: FC<FrontPanelOffModalProps> = (
  {
    open,
    onClose,
  },
) => {

  const classes = useStyles();
  const { t } = useTranslation();
  const [note, setNote] = useState('');

  const dispatch = useDispatch();

  const onModalClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onModalClose}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{
        square: true,
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant={'h5'}>
          {t('frontpanel_off_title')}
        </Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onModalClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>
        { t('frontpanel_off_description_1')}
        </Typography>
        <Typography>
        { t('frontpanel_off_description_2')}
        </Typography>
        <Typography>
        { t('frontpanel_off_description_3')}
        </Typography>
        <Typography>
        { t('frontpanel_off_description_4')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={onClose}
          color="secondary"
          variant={'contained'}
          size={'small'}
        >
          {t('frontpanel_off_button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};